// export const BASE_URL = 'http://localhost:3000';
// export const BASE_URL = 'https://mail.абсолютмедиа.рф';
export const BASE_URL = 'https://абсолютмедиа.рф';

// export const API_URL = 'http://localhost:3001';
// export const API_URL = 'https://mail.абсолютмедиа.рф:3001';
export const API_URL = 'https://абсолютмедиа.рф:3001';

export const API_PRODUCTS = API_URL + '/api/products';
export const API_ORDERS = API_URL + '/api/orders';